/**
 * `/v1/markets` `status` query-param tokens (contract lifecycle states).
 *
 * Comma-separated values match the backend list-markets filter parser
 * (`STATUS_VALUES` from `@morfi/contract-sdk` `MarketStatus`).
 *
 * @see packages/backend-sdk-v2/openapi.json — search `status` enum
 */

/** Actively tradeable markets — maps to the UI "Open" tab. */
export const MARKETS_LIST_OPEN_STATUS = 'trading' as const;

/** Post-resolution markets — maps to the UI "Resolved" tab (`isResolved` = resolved | graduated). */
export const MARKETS_LIST_RESOLVED_STATUS = 'resolved,graduated' as const;

/** Trending / search empty-state — tradeable markets sorted by trending score. */
export const TRENDING_SEARCH_STATUS = 'trading' as const;
